export enum BFXNotificationEventType {
  ORDER_UPDATE_EVENT,
  ACTION_FAIL_EVENT,
  ORDER_ENTRY_EVENT,
  TRADE_UPDATE_EVENT,
  INTERVENTION_UPDATE_EVENT,
  OPS_INTERVENTION_UPDATE_EVENT,
  RATE_EVENT,
  DETAIL_FILL_UNLOCK_EVENT,
  BMARK_FIXING_UPDATE_EVENT,
  SYSTEM_MONITOR_EVENT,
  EXPORT_ERROR_EVENT,
  ALGO_INFLIGHT_EVENT,
  ALGO_INFLIGHT_FAILED,
  MESSAGE,
  POSITION,
  SESSION_END,
  FIXING_RATE_REQUIREMENT,
  FWD_ROLL_PRICE,
  LIMIT_ORDER_ENTRY_EVENT,
  BENCHMARK_ORDER_ENTRY_EVENT,
}
